module.exports = __webpack_public_path__ + "static/media/html.2ea01c0e.png";